export default __webpack_public_path__ + "static/media/company-qr.e9ac6c9e.png";